module.exports = __webpack_public_path__ + "static/media/Plus.5346fc8d.svg";